/*
    default prefix "CLICK_MANAGER"
*/

export const AT_CLICK_MANAGER_SET = 'CLICK_MANAGER_SET';
export const AT_INITIAL_STATE_SET = 'CLICK_MANAGER_INITIAL_STATE_SET';
